module.exports = __webpack_public_path__ + "static/media/add-student.f9e5efb8.png";